import React, { useEffect, useState } from "react";
import {
  sessionQrcodeGenerate,
  sendDeliverySessionAPI,
  addingPendingDeliveries,
} from "../../services/delivery_api";
import { useDeliverySession } from "../../hooks/useDeliverySession";
import LoadingSpinner from "../common/LoadingSpinner";

const DeliveryQRCode = ({ setStep }) => {
  const [qrUrl, setQrUrl] = useState(null);
  const { session, setSession } = useDeliverySession();
  const [isLoading, setIsLoading] = useState(false);
  console.log("session data ", session);

  // calculating total number of delivery
  useEffect(() => {
    if (session?.deliveries) {
      const deliveryCount = Object.keys(session.deliveries).length;
      console.log("📦 Delivery count:", deliveryCount);

      const updatedSession = {
        ...session,
        total_no_of_delivery: deliveryCount, // ✅ just replace, no addition
      };

      setSession(updatedSession);
      localStorage.setItem("deliverySession", JSON.stringify(updatedSession));

      console.log(
        "✅ Updated session with total deliveries:",
        updatedSession.total_no_of_delivery
      );
    }

    // then fetch QR
    if (session?.delivery_qr_code_shortlink?.delivery_qr_short_url) {
      const qrCodeImage =
        session.delivery_qr_code_shortlink.delivery_qr_short_url;
      console.log("✅ QR Code URL:", qrCodeImage);
      setQrUrl(qrCodeImage);
    } else {
      console.log("❌ No QR code URL found in session data");
    }
    // getQRCodeforDelivery();
  }, []);

  const handleSubmit = async (stepNumber) => {
    try {
      // 🟦 STEP 6: View Chart — skip API calls, only navigate
      if (stepNumber === 6) {
        console.log("📊 Navigating to chart view...");
        setStep(6);
        return;
      }

      // 🟩 STEP 1: Full logic for home page
      if (stepNumber === 1) {
        console.log("🏠 Handling Home Page submission...");

        // Common base update
        const updatedSession = {
          ...session,
          web_status: "completed",
        };

        // Update state + localStorage
        setSession(updatedSession);
        localStorage.setItem("deliverySession", JSON.stringify(updatedSession));

        console.log("session data complete", updatedSession);

        // Send to backend API
        const sendResult = await sendDeliverySessionAPI(updatedSession);
        console.log("✅ Session sent to API:", sendResult);

        // Extract data from session to prepare payload for the API
        const pendingPayload = {
          da_id: session.da_id, // Assuming da_id is stored in session
          phone_number: session.phone_number, // Assuming phone_number is in session
          da_name: session.da_name, // Assuming da_name is in session
          created_at: session.created_at, // Set the current timestamp
          session_file_name: session.deliveries[0]?.session_file_name, // Assuming session_file_name is in session
          complex_location: session.deliveries[0]?.complex_location, // Get complex_location from the first delivery
          complex_name: session.deliveries[0]?.complex_name, // Get complex_name from the first delivery
          pincode: session.deliveries[0]?.pincode, // Get pincode from the first delivery
        };

        console.log("📤 Payload for addingPendingDeliveries:", pendingPayload);

        // Call the `addingPendingDeliveries` API (new API call)
        // const pendingDeliveriesResponse = await addingPendingDeliveries(
        //   pendingPayload
        // );
        // console.log("✅ Pending deliveries added:", pendingDeliveriesResponse);

        // Clear ONLY deliveries (keep rest of session)
        const clearedSession = {
          ...updatedSession,
          deliveries: {},
          web_status: "active",
          total_no_of_delivery: 0,
          delivery_qr_code_shortlink: "",
          dp_web_session_otp: "",
        };

        setSession(clearedSession);
        localStorage.removeItem("returnToStep");
        localStorage.setItem("deliverySession", JSON.stringify(clearedSession));

        console.log("🧹 Cleared session and going to Home Page...");
        setStep(1);
      }
    } catch (err) {
      console.error("❌ Failed to send session:", err);
    }
  };

  const getQRCodeforDelivery = async () => {
    try {
      const file_ident_code = session.file_ident_code;
      const complex_location = session.deliveries[0].complex_location;
      const complex_name = session.deliveries[0].complex_name;
      const session_file_name = session.deliveries[0].session_file_name;
      const phone_number = session.phone_number;

      const payload = {
        file_ident_code,
        complex_location,
        complex_name,
        session_file_name,
        phone_number,
      };

      console.log("payload of qr", payload);

      setIsLoading(true);

      //if delivery_qr_code_shortlink is empty calling api and storaging it
      if (session.delivery_qr_code_shortlink === "") {
        const response = await sessionQrcodeGenerate(payload);
        const qrCodeImage = response?.data?.qr_code_image;
        console.log("✅ QR Code URL:", qrCodeImage);
        setQrUrl(qrCodeImage);
        const updatedSession = {
          ...session,
          delivery_qr_code_shortlink: qrCodeImage,
        };
        setSession(updatedSession);
        localStorage.setItem("deliverySession", JSON.stringify(updatedSession));
        console.log("calling api of QR image");
      } else {
        const qrCodeImage = session.delivery_qr_code_shortlink;
        console.log("✅ QR Code URL:", qrCodeImage);
        setQrUrl(qrCodeImage);
      }

      setIsLoading(false);
    } catch (err) {
      console.error("❌ Failed to Get QR:", err);
    }
  };

  return (
    <div className="flex flex-col items-center px-4 py-4">
      {isLoading && <LoadingSpinner message="Loading Data, Please Wait…" />}

      <h2 className="text-center text-2xl sm:text-3xl md:text-4xl font-semibold text-blue-900 mb-4">
        Arrived at The Mail Whale locker? Scan the QR to store your parcel
        instantly.
      </h2>

      <div className="flex justify-center items-center mb-6">
        {qrUrl ? (
          <img
            src={qrUrl}
            alt="QR not Visible, Please Refresh ⟲"
            className="w-64 h-64 sm:w-72 sm:h-72 md:w-80 md:h-80 lg:w-96 lg:h-96 xl:w-[28rem] xl:h-[28rem] object-contain"
          />
        ) : (
          <div className="w-64 h-64 sm:w-72 sm:h-72 md:w-80 md:h-80 lg:w-96 lg:h-96 xl:w-[28rem] xl:h-[28rem] bg-gray-200 rounded-xl animate-pulse relative overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 animate-[shimmer_1.5s_infinite]" />
          </div>
        )}
      </div>

      {/* OTP BOXES */}
      { session?.dp_web_session_otp && (
        <div className="flex justify-center mt-4 gap-3">
          {session.dp_web_session_otp.split("").map((digit, index) => (
            <div
              key={index}
              className="w-10 h-10 flex items-center justify-center bg-white rounded-xl text-xl font-semibold text-gray-700 border-2 border-[#DDDDDD]"
            >
              {digit}
            </div>
          ))}
        </div>
      )}

      <div className="flex flex-row justify-center gap-4 mt-6 flex-wrap">
        <button
          className="bg-blue-900 text-white font-semibold py-3 px-6 rounded-xl text-base sm:text-lg shadow-md transition duration-200 hover:bg-blue-800"
          onClick={() => handleSubmit(6)}
        >
          View Chart
        </button>

        <button
          className="bg-white text-black font-semibold py-3 px-6 rounded-xl text-base sm:text-lg shadow-md transition duration-200 hover:bg-gray-100"
          onClick={() => handleSubmit(1)}
        >
          Home Page
        </button>
      </div>
      <h5 className="flex justify-center items-center text-center sm:text-3xl md:text-3xl font-semibold text-blue-900 mb-10 py-8 flex-wrap">
        <span>Find QR code, Sent on</span>
        <button
          onClick={() => window.open("https://wa.me/919892233593", "_blank")}
          className="inline-flex items-center gap-2 text-green-500 font-semibold px-4 py-2 rounded-lg transition duration-200"
        >
          <img
            src={require("../../assets/images/whatsapp_icon.png")}
            alt="WhatsApp"
            className="w-6 h-6"
          />
          WhatsApp
        </button>
      </h5>
    </div>
  );
};

export default DeliveryQRCode;
